import {getWasteDataSource, getWasteFamiliesDataSource} from '@store/settings/wasteFamilies/wasteFamilies.requests';
import {wasteFamiliesStore} from '@store/settings/wasteFamilies/wasteFamilies.store';
import {entitiesPropsFactory, getEntity} from '@ngneat/elf-entities';

const {wasteEntitiesRef} = entitiesPropsFactory('waste');

export class WasteFamiliesQuery {
  store = wasteFamiliesStore;

  wasteFamilies$ = getWasteFamiliesDataSource.data$();
  allWastes$ = getWasteDataSource.data$();

  wasteFamilyById = (wasteFamilyId: number) => this.store.query(getEntity(wasteFamilyId));
  wasteById = (wasteId: number) => this.store.query(getEntity(wasteId, {ref: wasteEntitiesRef}));
}

export const wasteFamiliesQuery = new WasteFamiliesQuery();